export const searchParamsKeyToChinese = {
    caseNumber: '人民调解编号',
    reporterName: '报案人',
    reporterPhone: '报案人联系电话',
    institutionName: '医疗单位',
    policyNumber: '保险单号',
    casePriority: '案件优先级',
    victimName: '患者',
    insuranceCompany: '保险公司',
    insuranceName: '保险名称',
    insuranceType: '保险类型'
};
